import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useMemo } from 'react';
import { pageScrollDown } from '../SummaryPage';
import {
  PageTitleAndSubTitle,
  WasteCalculatorCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import { useStores } from '../../stores';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { useNavigate, useParams } from 'react-router-dom';
import accessDashboardConstants from '../../core-utils/messages/AccessDashboardConstants';
import { toJS } from 'mobx';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';

type Params = {
  category: string;
};

export interface accessDashboardInternalProps {}

const getCategory = (category: string) => {
  const cards =
    category === 'Cohort Analysis'
      ? accessDashboardConstants.CUSTOM_ANALYSIS_CARDS
      : accessDashboardConstants.DASHBOARD_CARDS;

  return cards.find((item) => item.category === category);
};

const AccessDashboardInternal: React.FC<accessDashboardInternalProps> = observer(
  ({}) => {
    const loginPageStore = useStores().loginPageStore;
    const userAccessRoutes = toJS(loginPageStore.userAccessRoutes);
    const { category: encodedCategory } = useParams<Params>();
    const category = decodeURIComponent(encodedCategory ?? '');

    const selectedDashboardCategory: any = useMemo(
      () => getCategory(category),
      [category],
    );

    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '40px 0px 66px 63px',
      },
    });
    const { classes } = useStyles();
    const navigate = useNavigate();

    const handleOnClickGroup = (path: any) => {
      if (userAccessRoutes.includes(path)) {
        navigate(path);
      } else {
        handleOpenSnackBar('SCREEN NOT ACCESSIBLE', 'error', 8000);
      }
    };

    //Snackbar
    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };

    const handleCloseSnackBar = (
      event?: React.SyntheticEvent,
      reason?: string,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });

    const Dashboard = React.memo(() => {
      return (
        <Grid container style={{ flexDirection: 'column' }}>
          <Grid style={{ marginBottom: '16px' }}>
            <Typography
              fontSize="18px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.highemphasis}
              lineHeight="26px"
            >
              {selectedDashboardCategory?.category}
            </Typography>
          </Grid>
          <Grid style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
            {selectedDashboardCategory?.subGroups?.map(
              (eachCateg: any, index: number) => {
                const hasAccess = userAccessRoutes.includes(eachCateg.path);
                return (
                  <div key={index}>
                    <WasteCalculatorCard
                      height="323px"
                      width="377px"
                      title={eachCateg?.group}
                      subTitle={eachCateg?.subTitle}
                      image={eachCateg?.image}
                      titleFont="16px"
                      showExternalLink={false}
                      imageHeight="193px"
                      showTooltip={true}
                      isNoAccess={!hasAccess}
                      handleOnClick={() => {
                        handleOnClickGroup(eachCateg?.path);
                      }}
                      truncatedSubTitleLength={140}
                    />
                  </div>
                );
              },
            )}
          </Grid>
        </Grid>
      );
    });
    return (
      <div>
        <Grid container className={classes.root}>
          <Grid
            style={{
              marginBottom: '36px',
              width: '1182px',
              position: 'relative',
            }}
          >
            <PageTitleAndSubTitle
              title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography
                      fontSize="18px"
                      lineHeight="22px"
                      fontType="semiBold"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                    >
                      {selectedDashboardCategory?.category}
                    </Typography>
                  </div>
                </div>
              }
              subTitle={selectedDashboardCategory?.subTitle}
              showDownloadButton={false}
              showQueryDataButton={false}
            />
          </Grid>
          <Dashboard />
          <Snackbar
            {...snackbarState}
            handleClose={handleCloseSnackBar}
            vertical="bottom"
            horizontal="right"
          />
          <div id="scroll-top-element" />
        </Grid>
        {pageScrollDown('scroll-top-element')}
      </div>
    );
  },
);
export default AccessDashboardInternal;
